import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileNavActive, setMobileNavActive] = useState(false);
  const location = useLocation();

  // Reset scroll and close mobile menu on route change
  useEffect(() => {
    setMobileNavActive(false);
    document.body.classList.remove('mobile-nav-active');
    window.scrollTo(0, 0);
  }, [location]);

  // Handle scroll to add the "sticked" class to the header
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileNav = () => {
    const nextState = !mobileNavActive;
    setMobileNavActive(nextState);
    if (nextState) {
      document.body.classList.add('mobile-nav-active');
    } else {
      document.body.classList.remove('mobile-nav-active');
    }
  };

  return (
    <header id="header" className={`header d-flex align-items-center fixed-top ${scrolled ? 'sticked' : ''}`}>
      <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
        
        {/* Logo */}
        <NavLink to="/" className="logo d-flex align-items-center">
          <img src="/assets/img/PerfectSignsLogoFinal.jpg" alt="Perfect Signs Logo" />
          <h1 className="d-flex align-items-center">PERFECT SIGNS</h1>
        </NavLink>

        {/* Mobile Navigation Icons */}
        {!mobileNavActive ? (
          <i className="mobile-nav-toggle mobile-nav-show bi bi-list" onClick={toggleMobileNav}></i>
        ) : (
          <i className="mobile-nav-toggle mobile-nav-hide bi bi-x" onClick={toggleMobileNav}></i>
        )}

        {/* Navbar */}
        <nav id="navbar" className="navbar">
          <ul>
            <li>
              <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''}>
                About
              </NavLink>
            </li>
            <li>
              <NavLink to="/signage" className={({ isActive }) => isActive ? 'active' : ''}>
                Signage
              </NavLink>
            </li>
            <li>
              <NavLink to="/services" className={({ isActive }) => isActive ? 'active' : ''}>
                IT Services
              </NavLink>
            </li>
            <li>
              <NavLink to="/marketing" className={({ isActive }) => isActive ? 'active' : ''}>
                Marketing
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>
                Contact
              </NavLink>
            </li>
          </ul>
        </nav>

      </div>
    </header>
  );
}
